import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _dec, _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { inject, observer } from 'mobx-react';
var RequirePerms = (_dec = inject(['rootStore']), _dec(_class = observer(_class = /*#__PURE__*/function (_React$Component) {
  function RequirePerms() {
    _classCallCheck(this, RequirePerms);
    return _callSuper(this, RequirePerms, arguments);
  }
  _inherits(RequirePerms, _React$Component);
  return _createClass(RequirePerms, [{
    key: "hasPerms",
    value: function hasPerms(subject, type) {
      var permissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return type === 'all' ? subject.hasAllPermissions(permissions) : subject.hasSomePermissions(permissions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        anyOf = _this$props.anyOf,
        allOf = _this$props.allOf,
        children = _this$props.children;
      var subject = this.props.subject || this.props.rootStore.sessionStore.member;
      var subjects = this.props.subjects || [];
      var pass = false;
      if (subjects.length > 0) {
        var hasPermissions = subjects.reduce(function (prev, curr) {
          return prev || _this.hasPerms(curr, 'any', anyOf) && _this.hasPerms(curr, 'all', allOf);
        }, pass);
        pass = hasPermissions;
      } else {
        var _hasPermissions = this.hasPerms(subject, 'any', anyOf) && this.hasPerms(subject, 'all', allOf);
        pass = _hasPermissions;
      }
      return typeof children === 'function' ? this.props.children(pass) : pass ? children : null;
    }
  }]);
}(React.Component)) || _class) || _class);
export { RequirePerms as default };
//# sourceMappingURL=index.js.map
